__turbopack_context__.v({
  "inputWrapper": "styles-module__n7TkEa__inputWrapper",
  "shippingCostText": "styles-module__n7TkEa__shippingCostText",
  "totalOfferPriceWithFeeQuote": "styles-module__n7TkEa__totalOfferPriceWithFeeQuote",
});
